import React from 'react';

import { useAnimateInRef } from '../../../utils/hooks';

import * as styles from './ForecastTemperature.module.scss';

interface ForecastTemperatureProps {
  temperature: number;
  animationDelay: number;
}

const ForecastTemperature = ({
  temperature,
  animationDelay,
}: ForecastTemperatureProps): React.ReactElement => {
  return (
    <p ref={useAnimateInRef(styles.animateIn, animationDelay)} className={styles.temperature}>
      {Math.round(temperature)}
      <span className={styles.unitDot}></span>
    </p>
  );
};

export default ForecastTemperature;
